import React, { useEffect, useState } from "react";
import CardComponent from "../cardComponents/CardComponent";
import AccordionComponent from "../accordion/AccordionComponent";
// import { CreditCardData } from './CardData'
import Http from "../../Http";
import { CARD_API } from "../../Helper";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

import FAQSchema from "../../FAQSchema";
import { BadgeCheck, FileText } from "lucide-react";
import { motion } from "framer-motion";
import {
  FaTags,
  FaRegCheckCircle,
  FaArrowRight,
  FaFileAlt,
  FaUpload,
} from "react-icons/fa";

const Au = () => {
  const [CreditCardData, setCreditCardData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [cardsPerPage] = useState(10);
  const [activeIndex, setActiveIndex] = useState(0);

  const toggleAccordion = (index) => {
    if (activeIndex === index) {
      // If the clicked question is already expanded, collapse it
      setActiveIndex(null);
    } else {
      // If the clicked question is not expanded, expand it
      setActiveIndex(index);
    }
  };
  function Icon({ id, open }) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${
          id === open ? "rotate-180" : ""
        } h-5 w-5 transition-transform`}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
        />
      </svg>
    );
  }
  useEffect(() => {
    Http.post(CARD_API)
      .then((res) => {
        setCreditCardData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;
  console.log({ indexOfLastCard, indexOfFirstCard });
  // const currentCards = CreditCardData.cards
  //   ?.filter((card) => card.category === "Credit card")
  //   .slice(indexOfFirstCard, indexOfLastCard);
  // console.log({ currentCards });

  const currentCards = CreditCardData.cards
    ?.filter((card) => card.title?.toLowerCase().includes("au"))
    .slice(indexOfFirstCard, indexOfLastCard);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const faqs = [
    {
      question: "What types of credit cards does AU Bank offer?",
      answer:
        "  AU Bank offers lifestyle, travel, and reward-oriented cards such as the Zenith, Vetta, and Altura cards, each designed with specific spending preferences and privileges in mind.",
    },
    {
      question: "Can I get a lifetime free AU Bank credit card?",
      answer:
        " Some AU Bank cards like the Altura and Altura Plus may come with a lifetime free option or annual fee waiver on meeting minimum annual spends. Always check the latest terms before applying.",
    },
    {
      question: "How long does it take to receive the AU Bank credit card?",
      answer:
        "  If approved, the physical card is usually dispatched within 7–10 working days. You may also receive a virtual card immediately for online use.",
    },
    {
      question: "What is the interest rate on AU Bank credit cards?",
      answer:
        " Interest rates vary by card and can range from 1.25% to 3.5% per month depending on your card type and credit profile.",
    },
    {
      question: " Is there any reward redemption platform for AU cards?",
      answer:
        "  Yes, AU Bank has a dedicated reward portal where users can redeem points for travel bookings, merchandise, gift vouchers, and more.",
    },
  ];

  const steps = [
    {
      icon: <FaTags className="h-6 w-6 text-orange-500" />,
      title: "Explore & Compare",
      description:
        " Browse through our handpicked selection of AU Bank credit cards. Each listing includes detailed features, reward structures, fees, and ideal user profiles.",
    },
    {
      icon: <FaRegCheckCircle className="h-6 w-6 text-green-500" />,
      title: "Check Eligibility",
      description:
        " Make sure you meet the eligibility criteria including income, age, and credit score for your desired AU Bank card.",
    },
    {
      icon: <FaArrowRight className="h-6 w-6 text-purple-600" />,
      title: "Click to Apply",
      description:
        "When you’re ready, click the ‘Apply Now’ button on your chosen card. You’ll be securely redirected to the official website of the issuing bank or financial institution to initiate your application.",
    },
    {
      icon: <FaFileAlt className="h-6 w-6 text-teal-500" />,
      title: "Gather Documents",
      description:
        " Keep the required documents like identity proof, address proof, and income proof ready before proceeding.",
    },
    {
      icon: <FaUpload className="h-6 w-6 text-amber-500" />,
      title: "Redirect to Bank Website",
      description:
        "Once you've shortlisted your preferred card, click on the Apply Now button. You’ll be securely redirected to AU Bank’s official website to complete the application.",
    },
  ];
  const ad = {
    image: "/assets/homeadd.png",
    link: "https://play.google.com/store/apps/details?id=com.myairtelapp&pcampaignid=web_share",
    altText: "Advertisement",
  };
  return (
    <>
      <Helmet>
        <title>
          Get Best AU Bank Credit Card 2024 - Compare &amp; Apply Now at
          TheFinmaster
        </title>
        <meta
          name="description"
          content="AU Credit Cards - Check all types of AU bank credit cards list &amp; their benefits to select the right card for you. Apply for top &amp; best AU credit card now. | Thefinmaster"
        />
        <meta
          name="keywords"
          content="au bank credit card, au bank rupay credit card, au bank altura credit card, au altura plus credit card, au bank credit card payments"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/au-bank/credit-card"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />

      <div className="w-full flex justify-center items-center px-4 mt-20">
        <a
          href={ad.link}
          target="_blank"
          rel="noopener noreferrer"
          className="w-full max-w-5xl"
        >
          <img
            src={ad.image}
            alt={ad.altText}
            className="w-full h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105"
          />
        </a>
      </div>
      <div className="w-full flex flex-col items-center ">
        <div className=" mt-10 w-full flex flex-col items-center justify-center bg-black h-[200px] md:h-[300px] shadow-lg mb-5 border-b-8 border-blue-600">
          <h1 className="text-white text-4xl md:text-7xl text-center font-medium">
            Credit Card
          </h1>
          <p className="text-gray-200 text-lg md:text-2xl pt-2 px-4 text-center">
            Experience financial freedom and flexibility with our credit card
            options.
          </p>
        </div>
        <div className="flex justify-center items-center  p-4 ">
          <div className="bg-white shadow-lg rounded-2xl p-6 max-w-7xl text-center mt-4">
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
              Explore the Most Popular Credit Cards from AU Small Finance Bank
            </h2>

            <p className="text-gray-600 leading-relaxed mt-3">
              AU Bank offers a range of thoughtfully designed credit cards
              catering to lifestyle, travel, and rewards. Discover the
              top-performing AU credit cards tailored to enhance your spending
              experience with exclusive perks and offers.
            </p>
          </div>
        </div>
        <h1 className="text-center font-bold text-2xl md:text-3xl  text-gray-800 my-10">
          Featured Credit Cards
        </h1>
        <div className="w-[95%] mx-auto flex gap-5 flex-wrap md:flex-nowrap justify-center mb-10">
          <div className="w-fit flex flex-col gap-8">
            {currentCards &&
              currentCards.map((item, index) => {
                return (
                  <>
                    {" "}
                    <CardComponent
                      key={index}
                      cardDetails={item}
                      Card_features={item?.Card_features}
                      fees={item?.fees}
                      cardName={item?.title}
                      cardImage={item?.image}
                      rating={item?.rating}
                      category={item?.category}
                      status={item?.status}
                      bank_link={item?.bank_link}
                    />{" "}
                  </>
                );
              })}
          </div>

          <div className="w-full relative ">
            <div className="sticky overflow-hidden top-20 w-full h-[500px] flex flex-col justify-between">
              {/* <div className="w-[70%] mx-auto">
                                  <h2 className="text-center font-medium pt-5 text-lg">
                                    <span className="font-semibold text-white">816 people</span>{" "}
                                    are on call with our advisors right now
                                  </h2>
                                </div> */}
              <div className="w-full mx-auto">
                <Link
                  to="https://play.google.com/store/apps/details?id=finance.global.travel.niyo&pcampaignid=web_share"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="w-[80%] mx-auto ">
                    <img src="/assets/neoside.png" alt="Advertisement" />
                  </div>
                </Link>
                <div className="bg-white">
                  {/* <h3 className="text-center text-blue-500 cursor-pointer font-semibold py-2">
                                      Know your advisor
                                    </h3> */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Pagination */}
        <ul className="flex justify-center mt-4">
          {currentCards &&
            CreditCardData.cards?.filter(
              (card) => card.category === "Credit card"
            ).length > 0 &&
            Math.ceil(
              CreditCardData.cards?.filter(
                (card) => card.category === "Credit card"
              ).length / cardsPerPage
            ) > 1 &&
            Array.from({
              length: Math.ceil(
                CreditCardData.cards?.filter(
                  (card) => card.category === "Credit card"
                ).length / cardsPerPage
              ),
            }).map((_, index) => (
              <li key={index} className="mx-1">
                <button
                  className={`px-3 py-1 rounded-lg ${
                    currentPage === index + 1
                      ? "bg-blue-500 text-white"
                      : "bg-gray-200 text-gray-800"
                  }`}
                  onClick={() => paginate(index + 1)}
                >
                  {index + 1}
                </button>
              </li>
            ))}
        </ul>

        {/* <div className='w-[95%] py-10'>
                <h1 className='text-center font-bold text-5xl my-10'>Frequently Asked Questions</h1>
                <AccordionComponent />
            </div> */}

        <div className="w-full px-2 py-2 bg-gradient-to-br from-sky-50 via-white to-sky-100 dark:from-gray-900 dark:to-gray-800">
          <div className="max-w-6xl mx-auto grid gap-10">
            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-sky-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <FileText className="w-8 h-8 text-sky-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Eligibility Criteria to Apply for AU Bank Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Minimum Age Requirement
                  </span>
                  <span>
                    {" "}
                    Applicant must be at least 21 years old for primary cards
                    and 18 years for add-on cards. This ensures financial
                    maturity and legal compliance.
                  </span>
                </div>

                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Good Credit Score
                  </span>
                  <span>
                    {" "}
                    A CIBIL score of 700 or above increases your chances of
                    approval. A strong credit history shows responsible
                    borrowing behavior and boosts your creditworthiness.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Residential Location
                  </span>
                  <span>
                    {" "}
                    AU Bank credit cards are currently offered in select cities
                    across India. You must reside in a location where AU Small
                    Finance Bank provides its services.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Nationality
                  </span>
                  <span>
                    {" "}
                    Only Indian citizens and residents are eligible to apply.
                    Valid proof of Indian identity and residence is mandatory
                    during the verification process.
                  </span>
                </div>
                <div className="p-5 bg-sky-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Stable Source of Income
                  </span>
                  <span>
                    {" "}
                    Salaried or self-employed individuals must have a stable
                    monthly income. While exact income requirements vary per
                    card, a minimum monthly income of ₹25,000–₹50,000 is
                    typically required for basic to premium AU cards.
                  </span>
                </div>
              </div>
            </div>

            <div className="bg-white dark:bg-gray-900 rounded-2xl shadow-lg p-6 md:p-10 border border-emerald-200 dark:border-gray-700 hover:shadow-xl transition-shadow">
              <div className="flex items-center gap-3 mb-6">
                <BadgeCheck className="w-8 h-8 text-emerald-600" />
                <span className="text-2xl md:text-3xl font-bold text-gray-800 dark:text-white">
                  Documents Required to Apply for AU Bank Credit Card
                </span>
              </div>
              <div className="grid sm:grid-cols-2 gap-6 text-gray-700 dark:text-gray-300">
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Identity
                  </span>
                  <span>
                    {" "}
                    Acceptable documents include Aadhaar Card, PAN Card,
                    Passport, or Voter ID. These validate your personal identity
                    and are essential for KYC compliance.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Address
                  </span>
                  <span>
                    {" "}
                    Utility bills (not older than 3 months), Aadhaar card,
                    Passport, or Rental Agreement are accepted. This helps in
                    verifying your current residential location.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Proof of Income
                  </span>
                  <span>
                    {" "}
                    Salaried individuals must submit the latest 3 months' salary
                    slips or Form 16. Self-employed individuals can submit the
                    latest ITR with income computation and business proof.{" "}
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Photograph
                  </span>
                  <span>
                    {" "}
                    One recent passport-sized photograph is required for the
                    application form.
                  </span>
                </div>
                <div className="p-5 bg-emerald-50 dark:bg-gray-800 rounded-xl sm:col-span-2">
                  <span className="block font-semibold text-gray-900 dark:text-white">
                    Pan Card
                  </span>
                  <span>
                    {" "}
                    A copy of your Permanent Account Number (PAN) card is
                    mandatory for credit-based evaluations and regulatory
                    compliance.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="px-4 py-10 md:px-8 max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-gray-800 text-center mb-4">
          How to Apply for a Fuel Credit Card
        </h2>
        <p className="text-gray-600 text-sm md:text-base mt-2 text-center mb-8">
          Applying for a fuel credit card is a seamless process that starts with
          the right research and ends at the official bank’s platform for final
          submission. Here’s how you can get started through TheFinMaster.com:
        </p>
        <div className="grid gap-6 md:grid-cols-2">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              className="flex items-start gap-4 p-4 rounded-xl bg-white dark:bg-gray-900 shadow-md border hover:shadow-lg transition"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="mt-1">{step.icon}</div>
              <div>
                <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-1">{`${
                  index + 1
                }. ${step.title}`}</h3>
                <p className="text-md text-gray-600 dark:text-gray-300">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
      <div className="max-w-4xl mx-auto py-6 px-2">
        <h1 className="text-2xl md:text-3xl font-semibold text-center mb-8">
          Frequently Asked Questions
        </h1>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="border rounded-lg overflow-hidden shadow-md"
            >
              <button
                onClick={() => toggleAccordion(index)}
                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
              >
                {faq.question}
                <Icon id={index} open={activeIndex} />
              </button>
              {activeIndex === index && (
                <div className="p-4 bg-gray-100">
                  <p className="text-gray-700">{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default Au;
